import React, {useEffect, useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import ErrorMessageBanner from '../ErrorMessageBanner.jsx';
import meta from '@core/scripts/helper/meta';

export default function Form(
    {defaultValues, className = '', onSubmit, onError, children, mode = 'onTouched', error, setIsValid, ref}
) {
    const [globalError, setGlobalError] = useState('');
    const hasGlobalError = Boolean(globalError);
    const {
        register,
        handleSubmit,
        getValues,
        clearErrors,
        setError,
        formState: {errors, touchedFields, isValid},
        trigger,
        control
    } = useForm({
        mode: mode,
        defaultValues: defaultValues
    });

    // See NH-1873: Workaround for interaction of two forms
    useEffect(() => {
        if (error) {
            const {type, message} = error;
            setError(type, {type: 'custom', message: message});
        }
    }, [error]);

    useEffect(() => {
        if (setIsValid) {
            setIsValid(isValid);
        }
    }, [isValid]);

    const onFormSubmit = (values, setError, setGlobalError) => {
        const expandedValues = {...values, csrf: meta.value('_csrf')};
        setGlobalError('');
        onSubmit?.(expandedValues, setError, setGlobalError);
    };

    const submit = (values) => onFormSubmit(values, setError, setGlobalError);

    return (
        <FormProvider
            register={register}
            formState={{errors, touchedFields, isValid}}
            getValues={getValues}
            setError={setError}
            clearErrors={clearErrors}
            trigger={trigger}
            control={control}
            handleSubmit={handleSubmit}
        >
            <form ref={ref} className={className} onSubmit={handleSubmit(submit, onError)} noValidate>
                <ErrorMessageBanner text={globalError} show={hasGlobalError} />
                {children}
            </form>
        </FormProvider>
    );
}